export default __webpack_public_path__ + "static/media/me3.ac657bf4.png";